import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});


export const conactUsApi = async(payload)=>{
    try {
        const response = await apiService.post('/submit-contact-us', payload)
        return response.data
    } catch (error) {
        
    }
}